import { render, staticRenderFns } from "./TeacherEdit.vue?vue&type=template&id=648dc55a"
import script from "../../controllers/teacher/teacher-edit.js?vue&type=script&lang=js&external"
export * from "../../controllers/teacher/teacher-edit.js?vue&type=script&lang=js&external"
import style0 from "./TeacherEdit.vue?vue&type=style&index=0&id=648dc55a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports